import React, { useCallback, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { messages } from './messages.tsx';

type ResetButtonProps = {
	onReset: () => void;
};

export const ResetButton = ({ onReset }: ResetButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const handleOnReset = useCallback(
		(mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'resetButton', {
				// If number of clicks is 0, button was actioned using the keyboard
				keyboard: mouseEvent.detail === 0,
			});
			onReset();
		},
		[onReset],
	);

	return (
		<Button appearance="subtle" onClick={handleOnReset}>
			{formatMessage(messages.clearAllButtonText)}
		</Button>
	);
};
